import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TenantService } from './tenant.service';

@Injectable({
   providedIn: 'root',
})
export class AuthService {
    public isLoggedIn;

    constructor(private tenantService: TenantService) {}

    isLoginAutenticated(): boolean {
        // Native: the active profile's token (persisted in Capacitor Preferences)
        // is the source of truth, so the session survives an app restart.
        if (Capacitor.isNativePlatform()) {
            const profileToken = this.tenantService.getConfig()?.token;
            if (profileToken) {
                return true;
            }
        }
        return !!localStorage.getItem('token');
    }
}